import { totalInteractionsConfig } from '@/lib/analytics/kpis/instagram/totalInteractions';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const totalInteractionsMVConfig = {
    ...totalInteractionsConfig,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
